module.exports = __webpack_public_path__ + "static/media/3.2.1ee62b9f.png";